import { EmployeeResource, employeeResource } from '@witkac/kartamiejska-resources';
import { Employee, SessionStorage, Profile } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł listy pracowników partnera
 *
 * @export
 * @class EmployeeModule
 * @extends {EntityModule<Employee, EmployeeResource>}
 */
export class EmployeeModule extends EntityModule<Employee, EmployeeResource> {
  constructor() {
    super(employeeResource);
    /**
     * Stan store
     *
     * @memberof ClientModule
     */
    this.state = {
      ...this.state,
      data: {
        profile: {
          id: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          mainImage: undefined,
          userId: undefined
        },
        login: undefined
      }
    };

    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę pracowników danego partnera
       *
       * @param context context
       * @param id id profilu do którego jest przypisany partner
       */
      list: async (context: any, id: number): Promise<void> => {
        const partnerId: number = parseInt(sessionStorage.getItem(SessionStorage.PARTNER_ID) as string, 10);
        const list = await employeeResource.employeeList(partnerId);
        context.commit('saveList', list);
      },
      /**
       * Dodaje encję
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: { profile: Profile }): Promise<void> => {
        data.profile.id = await this.resource.add(data);
        const partnerId: number = parseInt(sessionStorage.getItem(SessionStorage.PARTNER_ID) as string, 10);
        const list = await employeeResource.employeeList(partnerId);
        context.commit('saveList', list);
      },
      /**
       * Aktualizuje profil pracownika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        const userId = data.profile.userId;
        delete data.profile.userId;
        data.profile.id = await this.resource.update(data.id, data);
        data.profile.userId = userId;
        context.commit('update', data.profile);
        context.commit('setEntity', data.profile);
      }
    };

    const superRemove = this.mutations.remove;
    this.mutations = {
      ...this.mutations,
      /**
       * Zapisuje pracownika do store
       *
       * @param localState stan lokalny
       * @param profile profil klienta
       */
      setEntity(localState: any, profile: any): void {
        Object.keys(localState.data.profile)
          .filter(key => profile[key] !== undefined)
          .forEach(key => (localState.data.profile[key] = profile[key]));
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      },
      /**
       * Usuwa pracownika z listy
       *
       * @param localState stan lokalny
       * @param id identyfikator encji
       */
      remove(localState: any, args: { profileId: number }): void {
        superRemove(localState, args.profileId);
      }
    };
  }
}

export default new EmployeeModule();
